import React from "react";
import { CheckboxButtonGroup } from "./CheckboxButtonGroup.jsx";
import { useWatch } from "react-hook-form";

export function SiteFiltersInput({ name, siteFilters, formContext, ...rest }) {
  const { control } = formContext;

  const siteType = useWatch({ name: "siteType", control });

  if (!siteType) {
    return null;
  }

  const options = siteFilters[siteType];

  if (options.length === 0) {
    return null;
  }

  return (
    <CheckboxButtonGroup
      control={control}
      name={name}
      label="Do you want specific amentities?"
      options={options}
      size="sm"
      {...rest}
    />
  );
}
